import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { categorySearchSchema } from "../../../helpers/search.helpers";

export const Route = createFileRoute("/(app)/courses/")({
  validateSearch: zodValidator(categorySearchSchema),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/courses/$type",
      params: { type: "native" },
      search,
    });
  },
});
